import * as React from 'react';

export default function useVisibilityChange(): boolean {
  const [documentVisible, setDocumentVisibility] = React.useState<boolean>(true);

  React.useEffect(() => {
    const handleChange = () => {
      if (document.visibilityState !== 'visible') {
        setDocumentVisibility(false);
      } else {
        setDocumentVisibility(true);
      }
    };

    document.addEventListener('visibilitychange', handleChange);

    return () => {
      document.removeEventListener('visibilitychange', handleChange);
    };
  }, []);

  return documentVisible;
}
